import { IMemberTenantInfo } from './API';

const clientId = process.env.REACT_APP_CLIENT_ID! || '7c816beb-102f-49cd-88f7-06085e5df3ac';
const appClientId = process.env.REACT_APP_APP_CLIENT_ID! || '68da843f-2237-497c-8eef-7ada30ce2d21';
const redirectUri = process.env.REACT_APP_REDIRECT_URI! || 'https://portal.helmsoft.com/';
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL! || 'https://svr-eu.helmsoft.com';
const usageBaseUrl = process.env.REACT_APP_USAGE_BASE_URL! || 'https://365automate-usage.azurewebsites.net';
const apiScopePrefix = process.env.REACT_APP_API_SCOPE_PREFIX! || 'api://app.helmsoft.com/';

export class MSALConfigGen {
	private static msalConfig = {
		auth: {
			clientId,
			appClientId,
			authority: 'https://login.microsoftonline.com/',
			redirectUri,
			autoConsent: false, //This is specifically for the Graph Toolkit components, so they don't go asking for their own consent
		},
		cache: {
			cacheLocation: 'localStorage', // This configures where your cache will be stored
			storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
		},
	};

	public static getActiveTenantId(): string | null {
		return localStorage.getItem('tenantId');
	}

	public static setActiveTenantId(id: string) {
		localStorage.setItem('tenantId', id);
	}

	public static getStoredTenants(): IMemberTenantInfo[] {
		let tenantsJson = localStorage.getItem('tenantInfos');
		if (tenantsJson) {
			return JSON.parse(tenantsJson);
		}
		return [];
	}

	public static setStoredTenants(tenants: IMemberTenantInfo[]) {
		localStorage.setItem('tenantInfos', JSON.stringify(tenants));
	}

	public static getMsalConfig() {
		//Check for tenant ID in local storage
		let tenantId = MSALConfigGen.getActiveTenantId();

		let msalConfig = { ...this.msalConfig };
		if (tenantId) {
			msalConfig.auth.authority = `https://login.microsoftonline.com/${tenantId}`;
		} else {
			msalConfig.auth.authority = 'https://login.microsoftonline.com/common';
		}

		return msalConfig;
	}
}

// Add here the endpoints and scopes for the web API you would like to use.
export const apiConfig = {
	uri: apiBaseUrl + '/api',
	scopes: [apiScopePrefix + clientId + '/.default'],
	usageUri: usageBaseUrl + '/api',

	//Default graph scopes. We also ask for a SharePoint scope which gets appended to this.
	defaultGraphScopes: [
		'https://graph.microsoft.com/User.Read',
		'https://graph.microsoft.com/Group.Read.All',
		'https://graph.microsoft.com/User.ReadBasic.All',
	],
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	scopes: [
		'openid',
		'profile',
		apiScopePrefix + clientId + '/.default',
	],
	scopesOutsideOfTeams: [
		'openid',
		'profile',
		clientId + '/.default',
	],
	state: '',
};
